import {Component, OnInit} from '@angular/core';
import {UiTranslateLoaderService} from 'ui-shared';
import {PrimeNGConfig} from 'primeng/api';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {HvlConfigurationService} from '@hvlng/framework-bff/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'hr-rec-main',
    templateUrl: './hr-rec-main.component.html',
})
export class HrRecMainComponent implements OnInit {
    constructor(
        protected translateService: UiTranslateLoaderService,
        private primengConfig: PrimeNGConfig,
    ) {
        this.translateService = translateService;
        this.primengConfig = primengConfig;
    }

    ngOnInit(): void {
        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' });
        this.translateService.get('kovan.primeng').subscribe((res) => this.primengConfig.setTranslation(res));

    }
}
